import { render, staticRenderFns } from "./yxxq.vue?vue&type=template&id=597015b3&scoped=true&"
import script from "./yxxq.vue?vue&type=script&lang=js&"
export * from "./yxxq.vue?vue&type=script&lang=js&"
import style0 from "./yxxq.vue?vue&type=style&index=0&id=597015b3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597015b3",
  null
  
)

export default component.exports